/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { useCallback, useLayoutEffect } from 'fierry/react';

import { useBoundArg } from 'solis/navigation';

import Slider from 'solis/react/element/slider';


const OnValueCommit = ([ value ], setValue) =>
{
  setValue(value);
};


export default ({ scope, name, initial, min, max, ...props }) =>
{
  const [ value, setValue ] = useBoundArg(name, initial, scope);

  const bounded = Math.max(Math.min(value, max), min);

  // The bound arg or its default can fall outside [min, max] when the bounds depend on
  // context. Snap the arg back so every reader sees the bounded value.
  useLayoutEffect(() =>
  {
    if (value !== bounded)
    {
      setValue(bounded);
    }
  }, [ value, bounded ]);

  const onValueCommit = useCallback(OnValueCommit, [ setValue ]);

  return <Slider {...props} min = {min} max = {max} defaultValue = {[ bounded ]} onValueCommit = {onValueCommit} />;
};
